import { Box } from "@mui/material";

import { styled } from "@mui/material/styles";

export const FieldColumns = styled(Box)(({ theme }) => ({
  display: "grid",
  width: "100%",
  gap: theme.spacing(2),
  gridTemplateColumns: "1fr 1fr",
  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "1fr",
  },
})) as typeof Box;
